import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	DeleteFavoriteDoctor,
	DeleteFavoriteDoctorRequest,
	DeleteFavoriteDoctorResponse,
} from 'domain/usecases';

export class RemoteDeleteFavoriteDoctor implements DeleteFavoriteDoctor {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteFavoriteDoctorResponse>,
	) {}

	async delete(params: DeleteFavoriteDoctorRequest): Promise<DeleteFavoriteDoctorResponse> {
		const {signal, ...restParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
			signal,
			body: restParams,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
